module.exports = __webpack_public_path__ + "hotel-restaurant.17ef75d13c0721eb4581.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/hotel-restaurant/webfont/hotel-restaurant.ttf
// module id = ../../../../../src/assets/fonts/line-icons-pro/hotel-restaurant/webfont/hotel-restaurant.ttf
// module chunks = styles